// extracted by mini-css-extract-plugin
export var colorSquare = "_to-0";
export var danger = "_to-5";
export var lightPink = "_to-8";
export var neutralBlue = "_to-7";
export var neutralYellow = "_to-6";
export var normal = "_to-1";
export var primary = "_to-2";
export var primaryLight = "_to-3";
export var solidBlack = "_to-g";
export var solidGreen = "_to-b";
export var solidLightBlue = "_to-d";
export var solidNavy = "_to-c";
export var solidOrange = "_to-f";
export var solidPink = "_to-e";
export var solidRed = "_to-9";
export var solidYellow = "_to-a";
export var success = "_to-4";